module.exports = __webpack_public_path__ + "img/phone-mockups.d2c5eb55.png";